export default {
  1: 'Cartão de Crédito',
  2: 'Boleto',
  3: 'PIX',
}
